import React from "react";
import { Routes as ReactRouterRoutes, Route } from "react-router-dom";
import LandingPage from "../views/Landing.page";
import LoginPage from "../views/Login.page";
import { ProtectedRoute } from "./protected-route.component";
import HomePage from "../views/home.page";
import { LinkPage } from "../views/links.page";
import { CreatingPage } from "../views/Creator.page";
import { RoutesEnum } from "./Routes.enum";

export const Routes: React.FC = () => {
  return (
    <ReactRouterRoutes>
      <Route
        path={RoutesEnum.HOME}
        element={
          <ProtectedRoute>
            <LandingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesEnum.CREATE}
        element={
          <ProtectedRoute>
            <CreatingPage />
          </ProtectedRoute>
        }
      />

      <Route path={RoutesEnum.ROOT} element={<HomePage />} />
      <Route path={RoutesEnum.LINKS} element={<LinkPage />} />

      <Route path={RoutesEnum.LOGIN} element={<LoginPage />} />
    </ReactRouterRoutes>
  );
};

export default Routes;
